"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var resources = {
    translation: {
        ACTIONS: {
            FINISH: 'Finish',
            NEXT: 'Next',
            BACK: 'Back',
            CREATE_ACCOUNT: 'Create Account',
            OKAY: 'Okay',
            CANCEL: 'Cancel',
            CONTINUE: 'Continue',
            DONE: 'Done',
            LOG_IN: 'Log In',
            LOG_OUT: 'Log Out',
            CLICK_BUTTON: 'Click the button',
            UPDATE_REDUX: 'Click the button to update the redux store value!',
            CHANGE_LANGUAGE: 'Change Language here!',
            GO_HOME: 'Go to Home',
            GO_TEST: 'Go to Test Page',
            RESEND: 'Send Again',
            UPDATE: 'Update',
            REMEMBER: 'Remember Me',
            SUBMIT: 'Submit',
        },
        LABELS: {
            EMAIL: 'Email Address',
            USERNAME: 'Username',
            PASSWORD: 'Password',
            CURRENT_PASSWORD: 'Current Password',
            NEW_PASSWORD: 'New Password',
            OPTIONAL: 'Optional',
            FORGOT_PASSWORD: 'Forgot your password?',
            NEED_ACCOUNT: 'Need an account?',
            VIEW_ALL_EVENTS: 'View All {{count}} Events',
        },
        MESSAGES: {
            EMAIL_SENT: 'Email Sent',
            WELCOME: 'Welcome',
            WELCOME_PROJECT: 'Welcome to {{project}}',
            LOGIN_MESSAGE: "You are 'logged' in",
            CONGRATS: 'Congratulations!',
            CONTACT: 'Contact an Eaton Support Representative',
            ERROR: 'Error!',
            EMAIL_ENTRY_ERROR: 'Please enter a valid email',
            USERNAME_ENTRY_ERROR: 'Please enter a valid username',
            SUCCESS: 'Success',
            FAILURE: 'Failure',
            LOADING: 'Loading...',
            REQUEST_ERROR: 'Sorry, there was a problem sending your request.',
            PASSWORD_REQUIRED_ERROR: 'Password Required',
        },
        FORMS: {
            FIRST_NAME: 'First Name',
            LAST_NAME: 'Last Name',
            PHONE_NUMBER: 'Phone Number',
            PASSWORD: 'Password',
            CONFIRM_PASSWORD: 'Confirm Password',
            PASS_MATCH_ERROR: 'Passwords do not match',
            TOGGLE_PASSWORD_VISIBILITY: 'Toggle password visibility',
            RESET_PASSWORD: 'Reset Password',
            FIRST_NAME_LENGTH_ERROR: 'First name must be at least 1 characters',
            LAST_NAME_LENGTH_ERROR: 'Last name must be at least 1 characters',
        },
        PASSWORD_REQUIREMENTS: {
            LENGTH: '8-16 Characters',
            NUMBERS: 'One number',
            UPPER: 'One uppercase letter',
            LOWER: 'One lowercase letter',
            SPECIAL: 'One special character',
        },
    },
};
exports.default = resources;
